// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3Dhf8","label":"Section_label__35HVy","contentWrap":"Section_contentWrap__ceh-3","footer":"Section_footer__LTYT4","footerInner":"Section_footerInner__3xSKE"};